import { styled, flexCenter, flexColumn, rgba, Theme } from '@unfold/theme';
import { Card } from '@unfold/card';

export const RemoveIconContainer = styled.div`
  width: 24px;
  height: 24px;
  border-radius: 3px;
  opacity: 0;
  ${flexCenter}

  &:hover {
    background-color: ${rgba('#fff', 0.3)};
  }
`;

export const ColorContainer = styled(Card)`
  height: 185px;
  border-radius: 6px;
  transition: all 0.2s ease-in-out;
  cursor: pointer;
  ${flexCenter}
  ${flexColumn}

  &:hover {
    box-shadow: ${({ theme }): string =>
      theme.name === Theme.LIGHT ? `0px 10px 50px #e8e8e8` : `none`};
    transform: scale(1.02);

    .remove-icon {
      opacity: 1;
    }
  }
`;

export const ColorBackground = styled.div<{ color: string }>`
  width: 100%;
  background-color: ${({ color }): string => color};
  padding: 0 10px;
  position: relative;
  border-radius: 6px 6px 0 0;
  ${flexCenter}
  flex: 1;
`;

export const ColorLabel = styled.div`
  width: 100%;
  height: 39px;
  background-color: #fff;
  color: #1a1e1d;
  margin-top: 0;
  font-size: 12px;
  font-weight: 500;
  border-radius: 0 0 6px 6px;
  ${flexCenter}
`;
